var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{style:({ 'background-image': 'url(' + _vm.background + ')' }),attrs:{"id":"banner"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('evento.banner.titulo')))]),_c('p',[_vm._v(_vm._s(_vm.$t('evento.banner.descricao')))])])}
var staticRenderFns = []

export { render, staticRenderFns }